import React, { useEffect, useCallback } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import Header from "../Header/Index.js";
import { Modal, Button, Icon } from "rsuite";
import Pagination from "react-js-pagination";
import Helper from "../Helper";
import { Context } from "../Store/Store";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
var {
  DeviceListAPI,
  alldeleteUser,
  AllVehicleListAPI,
  DeviceDeleteAPI,
  UploadSerialConfigurationApi,
  ListSearchApi,
} = require("../Api/ApiRoutes");
var { apiRequest } = require("../Api/Service");
const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_SUCCESS":
      return {
        ...state,
        isSuccess: true,
        success: action.payload,
        disable: false,
      };
    case "FETCH_ERROR":
      return {
        ...state,
        isError: true,
        errors: action.payload,
        disable: false,
      };
    case "DEFAULT":
      return {
        disable: action.payload,
      };
    default:
      return state;
  }
};

// eslint-disable-next-line no-unused-vars
const FileSchema = Yup.object().shape({
  file: Yup.string().required("This Field is Required"),
});

const initialState = {
  isError: false,
  errors: [],
  isSuccess: false,
  success: "",
  disable: false,
};

function DevicesCodeList() {
  const [setloader] = React.useState(false);
  const [records, setrecords] = React.useState([]);
  const [result, setResult] = React.useState({});
  const [show, setShow] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState("");
  const [rsModal, setRsModal] = React.useState(false);
  const [currentId, setCurrentId] = React.useState(null);
  const [state, dispatch] = React.useContext(Context);
  const [locationKeys, setLocationKeys] = React.useState([]);
  const history = useHistory();
  // eslint-disable-next-line no-unused-vars
  const [LocalState, Localdispatch] = React.useReducer(reducer, initialState);
  const [sort_by, setSortBy] = React.useState(1);

  const Modalclose = () => {
    setRsModal(false);
    setShow(false);
  };
  const Modalopen = (e) => {
    setCurrentId(e.target.dataset.id);
    setRsModal(true);
  };
  var user = Helper.getStorageData("SESSION");
  var permissions = user.permissions;
  var location = useLocation();

  const getDeviceCodeList = useCallback(
    (page, sort) => {
      if (
        Helper.getPermissions(
          "device-read",
          permissions && permissions,
          "admin"
        ) ||
        user.type === "superadmin"
      ) {
        Helper.overlay(true);
        apiRequest(
          DeviceListAPI.method,
          DeviceListAPI.url + `?page=${page}&sort_by=${sort ?? sort_by}`
        )
          .then((response) => {
            if (response.data.code === 200) {
              let data = response.data.data;
              dispatch({ type: "SET_CALL_STATE", call_one: false });
              setrecords(data);
              dispatch({ type: "SET_SEARCH_STATE", search_list: false });
              setResult(response.data.meta);
              Helper.overlay(false);
            }
          })
          .catch((error) => {
            setErrorMsg(error);
            Helper.overlay(false);
          });
      }
    },
    [dispatch, permissions, sort_by, user.type]
  );

  const handleSearchPageChange = useCallback(
    (pageNumber) => {
      Helper.overlay(true);
      apiRequest(
        ListSearchApi.method,
        ListSearchApi.url +
          `serial?name=${state.searchedName}&page=${pageNumber}`
      )
        .then((response) => {
          if (response.data.code === 200) {
            let data = response.data;
            setrecords(data.data);
            setResult(data.meta);
            Helper.overlay(false);
          }
        })
        .catch((error) => {
          Helper.overlay(false);
          history.push(`${location.pathname}#error`);
        });
    },
    [history, location.pathname, state.searchedName]
  );

  useEffect(() => {
    return history.listen((location) => {
      if (history.action === "PUSH") {
        setLocationKeys([location.key]);
      }

      if (history.action === "POP") {
        if (locationKeys[1] === location.key) {
          let str = location.pathname;
          let id = str.substr(str.length - 1);
          // history.push(`/admin/devices-code-list/${id}`);
          dispatch({ type: "SET_ACTIVE_PAGE_STATE", set_active_page: +id });

          if (location.pathname.includes("devices-code-list")) {
            getDeviceCodeList(+id);
          }
          setLocationKeys(([_, ...keys]) => keys);
        } else {
          let str = location.pathname;
          let id = str.substr(str.length - 1);
          dispatch({ type: "SET_ACTIVE_PAGE_STATE", set_active_page: +id });

          if (location.pathname.includes("devices-code-list")) {
            getDeviceCodeList(+id);
          }
          setLocationKeys((keys) => [location.key, ...keys]);
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, history, locationKeys]);

  useEffect(() => {
    // if (location.hash !== "#search" && !state.searchedName) {
    //   dispatch({ type: "SET_STATE", response: [] });
    getDeviceCodeList(state.set_active_page, sort_by);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sort_by, state.set_active_page]);

  useEffect(() => {
    if (
      location.pathname.includes("devices-code-list") &&
      location.hash === "#search" &&
      state.searchedName
    ) {
      dispatch({ type: "SET_STATE", response: [] });
      handleSearchPageChange(state.set_active_page);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, location.hash, state.searchedName, state.set_active_page]);

  useEffect(() => {
    if (location.hash === "#error") {
      setrecords([]);
      setResult([]);
      //setShow(true);
      setErrorMsg("No record Found");
    }
  }, [dispatch, location, state.data, state.pagination]);

  // eslint-disable-next-line no-unused-vars
  function getcheckbox() {
    var array = [];
    var checkboxes = document.querySelectorAll(
      "input[name='subcheckbox']:checked"
    );
    for (var i = 0; i < checkboxes.length; i++) {
      array.push(checkboxes[i].value);
    }
    console.log("array", array);
    let params = new FormData();
    params.append("ids", array);
    let delete_property = window.confirm(
      "Are you sure you want to delete these records!"
    );
    if (delete_property) {
      apiRequest(alldeleteUser.method, alldeleteUser.url, params)
        .then((response) => {
          if (response.data.code === 200) {
            let data = records.filter((d) => {
              // eslint-disable-next-line eqeqeq
              return d.id != currentId;
            });
            setrecords(data);
            setRsModal(false);
            console.log("Success", response);
          } else {
            console.log("Failure", response);
          }
        })
        .catch((error) => {
          console.log("error", error);
          setShow(true);
          setErrorMsg(error.response.data.message);
        });
    }
  }

  // eslint-disable-next-line no-unused-vars
  function handleMainCheckBox(e) {
    var value = false;

    if (e.target.checked) {
      value = true;
    }

    Array.from(document.querySelectorAll("input[name='subcheckbox']")).forEach(
      (checkbox) => {
        checkbox.checked = value;
      }
    );
  }

  const deleteRecord = (e) => {
    //let params = new FormData();
    //params.append("id", e.target.dataset.id);
    // let delete_property = window.confirm(
    //   "Are you sure you want to delete this record!"
    // );
    // if (delete_property) {
    apiRequest(DeviceDeleteAPI.method, DeviceDeleteAPI.url + `${currentId}`)
      .then((response) => {
        if (response.data.code === 200) {
          getDeviceCodeList(state.set_active_page, sort_by);
          setRsModal(false);
          console.log("Success", response);
        } else {
          console.log("Failure", response);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setShow(true);
        setRsModal(false);
        setErrorMsg(error.response.data.message);
      });
    //}
  };

  const handlePageChange = (pageNumber) => {
    dispatch({ type: "SET_ACTIVE_PAGE_STATE", set_active_page: pageNumber });
    Helper.overlay(true);
    if (
      location.pathname.includes("devices-code-list") &&
      location.hash === "#search"
    ) {
      history.push(`/admin/devices-code-list/${pageNumber}#search`);
    } else {
      history.push(`/admin/devices-code-list/${pageNumber}`);
    }
  };
  // eslint-disable-next-line no-unused-vars
  const handleSubmit = (values) => {
    const form_data = Helper.formData(values);
    setloader(true);
    Helper.overlay(true);
    Localdispatch({ type: "DEFAULT", payload: true });
    apiRequest(
      UploadSerialConfigurationApi.method,
      UploadSerialConfigurationApi.url,
      form_data
    )
      .then((response) => {
        if (response.data.code === 200) {
          Localdispatch({
            type: "FETCH_SUCCESS",
            payload: response.data.message,
          });
          setloader(false);
          Helper.overlay(false);
        } else {
        }
      })
      .catch((error) => {
        //console.log(error);
        Localdispatch({
          type: "FETCH_ERROR",
          payload: error.response.data.data,
        });
        window.scrollTo(500, 0);
        setloader(false);
        Helper.overlay(false);
        setErrorMsg(error.response.data.message);
      });
  };

  const setDropDown = (e) => {
    setSortBy(e.target.value);

    getDeviceCodeList(state.set_active_page, e.target.value);
  };
  return (
    <React.Fragment>
      <Modal backdrop="static" show={rsModal} onHide={Modalclose} size="xs">
        <Modal.Body>
          <Icon
            icon="remind"
            style={{
              color: "#ffb300",
              fontSize: 24,
            }}
          />
          {"  "}
          Are you sure you want to delete this record?
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={deleteRecord} appearance="primary">
            Ok
          </Button>
          <Button onClick={Modalclose} appearance="subtle">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show} onHide={Modalclose}>
        <Modal.Body>
          <h5>{errorMsg}</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={Modalclose} appearance="subtle">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <div className="wrapper d-flex align-items-stretch">
        <Sidebar /> */}
      <div id="content">
        <Header />
        {Helper.getPermissions(
          "device-read",
          permissions && permissions,
          user.type
        ) ? (
          <div className="p-4">
            <div className="row pb-2 d-flex justify-content-between align-items-center border-bottom">
              <div className="col-lg-8 col-md-6">
                <div className="d-flex flex-row mb-3">
                  {
                    //Helper.getPermissions('usage-create',permissions) &&
                    <div className="p-2">
                      {Helper.getPermissions(
                        "device-create",
                        permissions && permissions,
                        user.type
                      ) && (
                        <NavLink
                          exact
                          to={`/admin/devices-code-add`}
                          className="btn btnn-user white bg-orange"
                          style={{ backgroundColor: user.background_color }}
                        >
                          ADD DEVICE
                        </NavLink>
                      )}
                    </div>
                  }
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="d-flex row align-items-center">
                  <div className="col-md-12 col-lg-3 pl-lg-0 pr-lg-0">
                    Results: {result.total ? result.total : "1"}
                  </div>
                  <div className="col-md-12 col-lg-9 pl-lg-0 pr-lg-0 row">
                  <label class="col-3 mt-auto">Sort By:</label>
                    <select
                      className="form-select form-control col-8 "
                      aria-label="Default select example"
                      name="sort_by"
                      onChange={setDropDown}
                    >
                      <option selected={sort_by === 1 ? true : false} value={1}>
                        Last created on top
                      </option>
                      <option selected={sort_by === 2 ? true : false} value={2}>
                        First created on top
                      </option>
                      <option selected={sort_by === 3 ? true : false} value={3}>
                        Alphabetically A-Z
                      </option>
                      <option selected={sort_by === 4 ? true : false} value={4}>
                        Alphabetically Z-A
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            {errorMsg && " "}
            <div className="row">
              {records.length
                ? records.map((record, index) => (
                    <div
                      className="card col-12 mt-3 shadow bg-white rounded"
                      key={index}
                    >
                      <div className="row">
                        <div className="col-md-12 col-lg-12  col-sm-12 pb-3 pt-2 my-auto">
                          {/*<i
                          className="fa fa-cog fa-3x text-center text-primary"
                          aria-hidden="true"
                ></i>*/}
                        </div>
                        <div className="col-md-12 col-lg-10  col-sm-12 pb-3 pt-2">
                          <div className="row pt-2">
                            <div className="col-6">
                              <input
                                type="checkbox"
                                className=""
                                name="subcheckbox"
                                defaultValue={record.id}
                                id="exampleCheck1"
                              />
                              {Helper.getPermissions(
                                "device-update",
                                permissions && permissions,
                                user.type
                              ) ? (
                                <NavLink
                                  className=" ml-3 font-weight-bold ml-3"
                                  exact
                                  to={`/admin/edit-device-code/${record.id}`}
                                >
                                  {record.serial}
                                </NavLink>
                              ) : (
                                <span>{record.id}</span>
                              )}
                            </div>
                          </div>
                          <div className="row pt-2">
                            <div className="col-md-4 col-lg-4 col-sm-12">
                              <strong>Device Product:</strong> {record.device}
                            </div>
                            <div className="col-md-4 col-lg-3 col-sm-12 pl-lg-0">
                              <strong>Device Status:</strong>{" "}
                              {record.status ? record.status : "-"}
                            </div>
                            <div className="col-md-4 col-lg-5 col-sm-12">
                              <strong>Server FallBack Path:</strong>{" "}
                              {record.server_fallback_path}
                            </div>
                          </div>
                          <div className="row pt-2">
                            <div className="col-md-4 col-lg-4 col-sm-12">
                              <strong>Date:</strong> {record.manufacturing_date}{" "}
                              (
                              {user?.timezone
                                ? user.timezone
                                : Helper.localTimezone()}
                              )
                            </div>
                            <div className="col-md-4 col-lg-3 col-sm-12 pl-lg-0">
                              <strong>Hardware:</strong>{" "}
                              {record.hardware.version}
                            </div>
                            <div className="col-md-4 col-lg-5 col-sm-12 ">
                              <strong>Server Path:</strong> {record.server_path}
                            </div>
                          </div>
                          <div className="row pt-2">
                            <div className="col-md-4 col-lg-4 col-sm-12 ">
                              <strong>Last Location: </strong>
                              {record.last_location?.lat !== null &&
                              record?.last_location?.long !== null ? (
                                <a
                                  href={`https://www.google.com/maps/search/?api=1&query=${record?.last_location?.lat},${record?.last_location?.long}`}
                                  target={`blank`}
                                >
                                  {record?.last_location?.lat +
                                    " " +
                                    record?.last_location?.long}
                                </a>
                              ) : (
                                "- -"
                              )}
                            </div>

                            <div className="col-md-4 col-lg-3 col-sm-12 pl-lg-0">
                              <strong>Sync with :</strong>{" "}
                              {record.vehicle ? (
                                <NavLink
                                  exact
                                  to={`/admin/edit-vehicle-details/${record.vehicle.id}`}
                                  r
                                >
                                 <b> {record.vehicle.name} </b>
                                </NavLink>
                              ) : (
                                "--"
                              )}
                            </div>
                            <div className="col-md-4 col-lg-5 col-sm-12">
                              <strong>Last online: </strong>{" "}
                              {record.last_online ? record.last_online : "-"}
                            </div>
                          </div>

                          <div className="row pt-2">
                            <div className="col-md-8 col-lg-7 col-sm-12">
                              <strong>Encryption Key:</strong>{" "}
                              {record.key
                                ? record.key.replace(/.(?=.{4})/g, "x")
                                : "-"}
                            </div>
                            <div className="col-md-4 col-lg-5 col-sm-12">
                              <strong>software_version:</strong>{" "}
                              {record.software_version
                                ? record.software_version
                                : "-"}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 col-sm-12  col-lg-2 ">
                          <div className="row pt-3 pt-lg-5 pb-3">
                            <div className="col-md-4  col-sm-4 col-lg-12 pt-lg-4">
                              {Helper.getPermissions(
                                "device-update",
                                permissions && permissions,
                                user.type
                              ) && (
                                <NavLink
                                  className=""
                                  exact
                                  to={`/admin/edit-device-code/${record.id}`}
                                >
                                  <button className="btn-success w-100">
                                    Edit
                                  </button>
                                </NavLink>
                              )}
                            </div>
                            <div className="col-md-4  col-sm-4 col-lg-12 pt-lg-3 pt-md-0 pt-2">
                              {Helper.getPermissions(
                                "device-delete",
                                permissions && permissions,
                                user.type
                              ) && (
                                <button
                                  className="btn-danger w-100 "
                                  data-id={record.id}
                                  onClick={Modalopen}
                                >
                                  Delete
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                : errorMsg && (
                    <div className="text-center ft-14 mt-3 font-weight-bold">
                      No Data Found...
                    </div>
                  )}
            </div>
            <div className="row mt-3 ft-14">
              <div className="col-md-12">
                <nav aria-label="Page navigation example">
                  <ul className="pagination justify-content-end">
                    {
                      <Pagination
                        activePage={state.set_active_page}
                        // itemsCountPerPage={result.to}
                        totalItemsCount={result.total ? result.total : 1}
                        pageRangeDisplayed={5}
                        itemClass="page-item"
                        linkClass="page-link"
                        onChange={handlePageChange}
                        activeClass={user.type === "whitelabel" ? "active-whitelabel-pagination" : "active-default-pagination "}
                      />
                    }
                    <li className="pl-3">
                      {/* <form className="form-inline">
                          <label className="my-1 mr-2">Results on page:</label>
                          <select
                            className="form-control p-0"
                            style={{ height: "30px" }}
                            defaultValue={"10"}
                          >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </form> */}
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        ) : (
          <div className="p-4">
            <div className="text-center ft-14 mt-3 font-weight-bold">
              You are not allowed to visit this screen...
            </div>
          </div>
        )}
      </div>
      {/* </div> */}
    </React.Fragment>
  );
}
export default DevicesCodeList;
